<template>
  <div>
    <TableBasic :payload="payload" @onChange="changeParameter">
      <template v-slot:child_order_id="{ data }">
        <div>
          <router-link
            :to="'/order/orders/' + data.id +'?detail=canceled&type_order=orderseller'"
            class="text-decoration-none fw-bold"
            style="color: #5e50a1"
          >
            {{ data.id }}
          </router-link>
        </div>
      </template>
      <template v-slot:buyer_name="{ value }">
        <div class="fw-bold" style="color: #5e50a1">
          {{ value }}
        </div>
      </template>
      <template v-slot:seller_store_name="{ value }">
        <div class="fw-bold" style="color: #5e50a1">
          {{ value }}
        </div>
      </template>
      <template v-slot:total_order="{ data }">
        <div>
          {{ filters.rupiah(data.order_seller_pricing ? data.order_seller_pricing.total_payment : 0) }}
        </div>
      </template>
      <template v-slot:cancel_date="{ value }">
        <div>
          {{ filters.dateFull(value ) }}
        </div>
      </template>
      <template v-slot:actions="{ data }">
        <div class="d-flex w-100">
          <router-link
            v-if="data.refund.id"
            :to="`/finance/refunds/${data.refund.id}`"
            class="btn btn-light text-danger fw-bold"
            :style="{height:'fit-content'}"
          >
            Check Refund
          </router-link>
          <button class="btn ms-auto" v-if="!data.additional_row" @click="data.additional_row = !data.additional_row">
            <font-awesome-icon icon="fa-solid fa-sort-down" class="mb-1 text-warning" />
          </button>
          <button class="btn mt-3 align-middle ms-auto" v-if="data.additional_row"
            @click="data.additional_row = !data.additional_row">
            <font-awesome-icon icon="fa-solid fa-sort-up" class="mb-1 text-warning" />
          </button>
        </div>
      </template>
      <template v-slot:canceled_date="{ value }">
        <div>
          {{ filters.dateSimple(value) }}
        </div>
      </template>
      <template v-slot:expiry_date="{ value }">
        <div>
          <span class="text-black-50">
            Automatically Cancelled if Pickup not yet requested by
          </span>
          <br />
          <span class="fw-bold">
            {{ filters.dateSimple(value) }}
          </span>
        </div>
      </template>
      <template v-slot:cancel="{ value }">
        <div v-for="data in value" :key="data" class="mb-5">
          <span class="text-black-50"> Cancellation Time </span>
          <br />
          <span class="fw-bold">
            {{ filters.dateSimple(data.cancel_time) }}
          </span>
          <br />
          <br />
          <span class="text-black-50"> Cancellation Reason </span>
          <br />
          <span class="fw-bold">
            {{ data.cancel_reason }}
          </span>
        </div>
      </template>
      <template v-slot:parent_order_id="{ data }">
        <div>
          <span class="text-black-50"> Parent Order ID </span>
          <br />
          <span class="text-secondary fw-bold">{{ data.order_id }}</span>
        </div>
      </template>
      <template v-slot:location_destination="{ data,value }">
        <div v-if="value">
          <font-awesome-icon icon="fa-solid fa-location-dot" class="pe-2 text-secondary" />
          <span class="fw-bold text-secondary">{{ value.city }}</span>
          <br />
          <span class="text-black-50"> Shipment Cost </span>
          <br />
          <span class="fw-bold">{{ filters.rupiah(data.order_seller_pricing.shipment_cost) }}</span>
        </div>
      </template>
      <template v-slot:location_origin="{ value }">
        <div v-if="value">
          <font-awesome-icon icon="fa-solid fa-location-dot" class="pe-2 text-secondary" />
          <span class="fw-bold text-secondary">{{ value.city }}</span>
          <br />
        </div>
      </template>
      <template v-slot:product="{ data }">
        <div>
          <span class="fw-bold mb-1"
            style="color: #5e50a1">{{ data.product_items.length > 0 ? `${data.product_items.length} Products` : '' }}</span>
        </div>
      </template>
    </TableBasic>
  </div>
</template>

<script>
  import TableBasic from "@/components/TableBasic.vue";
  export default {
    components: {
      TableBasic,
    },
    data() {
      return {
        payload: {
          filter: true,
          filterLabel: "Filter by Cancelled Date",
          datepickerOption: {
            autoApply: true,
            timePicker: false,
          },
          header: [{
              key: "child_order_id",
              label: "C. ORDER ID",
              class: "text-start",
            },
            {
              key: "buyer_name",
              label: "BUYER",
              class: "text-start",
            },
            {
              key: "seller_store_name",
              label: "SELLER",
              class: "text-start",
            },
            {
              key: "total_order",
              label: "TOTAL ORDER",
              class: "text-start",
              sort: true,
              sort_key: 'order_seller_pricing.total_payment'
            },
            {
              key: "cancel_date",
              label: "CANCELLED DATE",
              class: "text-start",
              sort: true,
              sort_key: 'cancel_date'
            },
            {
              key: "actions",
              label: "ACTIONS",
              class: "text-start",
            },
          ],
          second_header: [{
              key: "parent_order_id",
              label: "Child Order ID",
              class: "text-start",
            },
            {
              key: "location_destination",
              label: "",
              class: "text-start",
            },
            {
              key: "location_origin",
              label: "",
              class: "text-start",
            },
            {
              key: "product",
              label: "",
              class: "text-start",
            },
            {
              key: "",
              label: "",
              class: "",
            },
            {
              key: "cancel",
              label: "",
              class: "text-start",
            },
          ],
          value: [],
          totalRows: 1,
          checkbox: true,
          currentPage: 1,
          perPage: 10,
          pageOptions: [10, 20, 50, 100],
          search: true,
          startDate: "",
          endDate: "",
          searchPlaceholder: "Parent/Child Order ID/Buyer/Seller",
          searchContainerStyle: { maxWidth: '235px' },
          sortBy: "",
          sortType: "",
        },
        filterValue: {},
      };
    },
    methods: {
      changeParameter(value) {
        this.payload.perPage = value.per_page;
        this.payload.currentPage = value.current_page;
        this.payload.sortType = value.sort_type
        this.payload.sortBy = value.sort_by
        this.searchInput = value.search;
        this.filterValue = value.filter;
        this.getData();
      },
      async getData() {
        let payload = {
          page: this.payload.currentPage,
          size: this.payload.perPage,
          status: "SELLER_CANCELLED"
        };
        try{
          if (this.filterValue) {
            console.log(this.filterValue);
            payload.date_start = this.filterValue.from;
            payload.date_end = this.filterValue.to;
          }

          if(this.payload.sortBy) payload.sort_by = this.payload.sortBy
          if(this.payload.sortType) payload.sort_type = this.payload.sortType

          if (this.searchInput != "") {
            payload.keyword = this.searchInput;
          }

          const response = await this.$store.dispatch("order/getAllOrderSeller", payload);
          this.payload.value = response.items;
          this.payload.totalRows = response.count;
        }catch(error){
          console.log("ERROR : ", error)
          this.$swal({
            title: error.response?.data ?.errorMessage || error.message,
            icon: "warning",
            timer: 2000,
          })
        }
      },
    },
    mounted() {
      this.getData();
    },
  };
</script>

<style></style>
